import { ActionTree, GetterTree } from "vuex";

export interface ProtocollazioneStoreModel {
  corrispondenti: protocollazione.codifiche[]
  titolario: protocollazione.codifiche[]
  tipoDocumento: protocollazione.codifiche[]
  tramite: protocollazione.codifiche[]
}

export interface ProtocollazioneStoreGetters {
  corrispondenti: () => protocollazione.codifiche[]
  titolario: () => protocollazione.codifiche[]
  tipoDocumento: () => protocollazione.codifiche[]
  tramite: () => protocollazione.codifiche[]
}

export interface ProtocollazioneStoreActions {
  setCorrispondenti(data: protocollazione.codifiche[])
  setTitolario(data: protocollazione.codifiche[])
  setTipoDocumento(data: protocollazione.codifiche[])
  setTramite(data: protocollazione.codifiche[])
}

export const ProtocollazioneStore = {
  PREFIX: "protocollazione",
  namespaced: true,
  state: {
    corrispondenti: [],
    titolario: [],
    tipoDocumento: [],
    tramite: []
  },
  getters: {
    corrispondenti: (state: ProtocollazioneStoreModel) => () => state.corrispondenti,
    titolario: (state: ProtocollazioneStoreModel) => () => state.titolario,
    tipoDocumento: (state: ProtocollazioneStoreModel) => () => state.tipoDocumento,
    tramite: (state: ProtocollazioneStoreModel) => () => state.tramite
  } as GetterTree<ProtocollazioneStoreModel, ProtocollazioneStoreModel>,
  mutations: {
    SET__Corrispondenti(state: ProtocollazioneStoreModel, data: protocollazione.codifiche[]){
      state.corrispondenti = data;
    },
    SET__Titolario(state: ProtocollazioneStoreModel, data: protocollazione.codifiche[]){
      state.titolario = data;
    },
    SET__TipoDocumento(state: ProtocollazioneStoreModel, data: protocollazione.codifiche[]){
      state.tipoDocumento = data;
    },
    SET__Tramite(state: ProtocollazioneStoreModel, data: protocollazione.codifiche[]){
      state.tramite = data;
    },
  },
  actions: {
    setCorrispondenti({commit}, data: protocollazione.codifiche[]){
      commit("SET__Corrispondenti", data)
    },
    setTitolario({commit}, data: protocollazione.codifiche[]){
      commit("SET__Titolario", data)
    },
    setTipoDocumento({commit}, data: protocollazione.codifiche[]){
      commit("SET__TipoDocumento", data)
    },
    setTramite({commit}, data: protocollazione.codifiche[]){
      commit("SET__Tramite", data)
    }
  } as ActionTree<ProtocollazioneStoreModel, any>,
}


